<template>
  <path
    d="M9 6.00024C9 6.56024 9.45 7.00024 10 7.00024H15.59L4.7 17.8902C4.31 18.2802 4.31 18.9102 4.7 19.3002C5.09 19.6902 5.72 19.6902 6.11 19.3002L17 8.41024V14.0002C17 14.5502 17.45 15.0002 18 15.0002C18.55 15.0002 19 14.5502 19 14.0002V6.00024C19 5.45024 18.55 5.00024 18 5.00024H10C9.45 5.00024 9 5.45024 9 6.00024Z"
  />
</template>
